export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v22H0z" />
                <path
                    d="M12.991 11L9.683 7.692a.625.625 0 0 1 .884-.884l3.75 3.75a.625.625 0 0 1 0 .884l-3.75 3.75a.625.625 0 1 1-.884-.884L12.991 11z"
                    fill="#1A1A1A"
                />
            </g>
        </svg>
    );
}
